import React from 'react';
import { useParams } from 'react-router';
import { LoadingSpinner, VStack } from '@adc/parallax-component-library';
import i18n from '../../utilities/i18n';
import SensorHeader from './sensorComponents/SensorHeader';
import MessageBanner from '../messageBanner/MessageBanner';
import { useQuery } from '@tanstack/react-query';
import {
  deviceByKeyQueryOptions,
  sensorQueryOptions,
} from '../../queryOptions';

/**
 * Sensor component that displays the details of a specific sensor.
 * @returns {React.JSX.Element}
 */
export default function Sensor() {
  const { sensorKey } = useParams();

  const sensor = useQuery(
    sensorQueryOptions({ key: sensorKey }, { enabled: !!sensorKey }),
  );
  const device = useQuery(
    deviceByKeyQueryOptions(sensor.data?.deviceKey || '', {
      enabled: !!sensor.data?.deviceKey,
    }),
  );

  return (
    <VStack gap="$2" height="100%">
      {sensor.isPending || device.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="subject-loading-spinner" />
        </VStack>
      ) : null}

      {sensor.isError ? (
        <MessageBanner
          type="danger"
          headerText={i18n.t('Page_Sensor.error_loading_sensor')}
          bodyText={sensor.error.message}
        />
      ) : null}

      {sensor.isSuccess && device.isSuccess ? (
        <SensorHeader
          sensor={sensor.data}
          deviceId={device.data?.deviceId || ''}
        />
      ) : null}
    </VStack>
  );
}
